
import useLayoutStore from "@/store/create/createLayoutStore"

const layoutConfig = {
  renderType: window.innerWidth > 768 ? 'pc' : 'mobile',
}

export const initLayout = () => {
  layoutConfig.renderType = window.innerWidth > 768 ? 'pc' : 'mobile'
  useLayoutStore().setRenderType(layoutConfig.renderType)
  // mineStroe().isMobile = layoutConfig.renderType === 'mobile'
}


export default layoutConfig